<template>
    <div class="neue fsp20 lh28 text-black d-flex justify-content-between align-items-center" :class="{ 'mb32': this.isMobile, 'mb16': !this.isMobile }">
        <div v-if="this.isMobile">
            <Icon name="arrow-left" class="c24 pointer" @click="this.close()"/>
        </div>
        <div class="flex-grow-1 fsp20 lh28" :class="{ 'text-center mr24': this.isMobile }">
            {{ this.$store.state.modal.content.title }}
        </div>
        <div v-if="!this.isMobile">
            <Icon name="close" class="c24 pointer" @click="this.close()"/>
        </div>
    </div>
    <div class="text-black bg-white rounded12" :class="{ 'p-0': this.isMobile, 'p24': !this.isMobile }">
        <div class="pb24 mb24 border-b">
            <div class="d-flex justify-content-between mb16" :class="{ 'align-items-start': this.isMobile, 'align-items-center': !this.isMobile }">
                <div class="neue fsp20 lh28 text-black">{{ $t('components.service.modal.AssetsFilter.1') }}</div>
                <div class="fsp16 neue text-decoration-underline ml16 main-color pointer lh28" @click="this.clear('accept')">{{ $t('components.service.modal.AssetsFilter.2') }}</div>
            </div>
            <div class="d-flex flex-column gap-3">
                <div class="d-flex justify-content-between lh28">
                    <div class="neue-roman mr16">{{ $t('components.service.modal.AssetsFilter.3') }}</div>
                    <Checkbox id="accept" :dataValue="this.fields.accept === ''" @updateParentState="(arg) => this.setValue(arg, '')"/>
                </div>
                <div class="d-flex justify-content-between lh28">
                    <div class="neue-roman mr16">{{ $t('components.service.modal.AssetsFilter.4') }}</div>
                    <Checkbox id="accept" :dataValue="this.fields.accept === '0'" @updateParentState="(arg) => this.setValue(arg, '0')"/>
                </div>
                <div class="d-flex justify-content-between lh28">
                    <div class="neue-roman mr16">{{ $t('components.service.modal.AssetsFilter.5') }}</div>
                    <Checkbox id="accept" :dataValue="this.fields.accept === '1'" @updateParentState="(arg) => this.setValue(arg, '1')"/>
                </div>
            </div>
        </div>
        <div class="pb24 mb24 border-b">
            <div class="d-flex justify-content-between mb16" :class="{ 'align-items-start': this.isMobile, 'align-items-center': !this.isMobile }">
                <div class="neue fsp20 lh28 text-black neue-roman">{{ $t('components.service.modal.AssetsFilter.6') }}</div>
                <div class="fsp16 neue text-decoration-underline ml16 main-color pointer lh28" @click="this.clear('active')">{{ $t('components.service.modal.AssetsFilter.2') }}</div>
            </div>
            <div class="d-flex flex-column gap-3">
                <div class="d-flex justify-content-between lh28">
                    <div class="neue-roman mr16">{{ $t('components.service.modal.AssetsFilter.7') }}</div>
                    <Checkbox id="active" :dataValue="this.fields.active === '1'" @updateParentState="(arg) => this.setValue(arg, '1')"/>
                </div>
                <div class="d-flex justify-content-between lh28">
                    <div class="neue-roman mr16">{{ $t('components.service.modal.AssetsFilter.8') }}</div>
                    <Checkbox id="active" :dataValue="this.fields.active === '0'" @updateParentState="(arg) => this.setValue(arg, '0')"/>
                </div>
            </div>
        </div>
        <div class="pb24 mb24 border-b">
            <div class="d-flex justify-content-between mb16" :class="{ 'align-items-start': this.isMobile, 'align-items-center': !this.isMobile }">
                <div class="neue fsp20 lh28 text-black">{{ $t('components.service.modal.AssetsFilter.9') }}</div>
                <div class="fsp16 neue text-decoration-underline ml16 main-color pointer lh28" @click="this.clear('access_atm_buy')">{{ $t('components.service.modal.AssetsFilter.2') }}</div>
            </div>
            <div class="d-flex flex-column gap-3">
                <div class="d-flex justify-content-between lh28">
                    <div class="neue-roman mr16">{{ $t('components.service.modal.AssetsFilter.7') }}</div>
                    <Checkbox id="access_atm_buy" :dataValue="this.fields.access_atm_buy === '1'" @updateParentState="(arg) => this.setValue(arg, '1')"/>
                </div>
                <div class="d-flex justify-content-between lh28">
                    <div class="neue-roman mr16">{{ $t('components.service.modal.AssetsFilter.8') }}</div>
                    <Checkbox id="access_atm_buy" :dataValue="this.fields.access_atm_buy === '0'" @updateParentState="(arg) => this.setValue(arg, '0')"/>
                </div>
            </div>
        </div>
        <div class="pb24 mb24 border-b">
            <div class="d-flex justify-content-between mb16" :class="{ 'align-items-start': this.isMobile, 'align-items-center': !this.isMobile }">
                <div class="neue fsp20 lh28 text-black">{{ $t('components.service.modal.AssetsFilter.10') }}</div>
                <div class="fsp16 neue text-decoration-underline ml16 main-color pointer lh28" @click="this.clear('access_atm_sell')">{{ $t('components.service.modal.AssetsFilter.2') }}</div>
            </div>
            <div class="d-flex flex-column gap-3">
                <div class="d-flex justify-content-between lh28">
                    <div class="neue-roman mr16">{{ $t('components.service.modal.AssetsFilter.7') }}</div>
                    <Checkbox id="access_atm_sell" :dataValue="this.fields.access_atm_sell === '1'" @updateParentState="(arg) => this.setValue(arg, '1')"/>
                </div>
                <div class="d-flex justify-content-between lh28">
                    <div class="neue-roman mr16">{{ $t('components.service.modal.AssetsFilter.8') }}</div>
                    <Checkbox id="access_atm_sell" :dataValue="this.fields.access_atm_sell === '0'" @updateParentState="(arg) => this.setValue(arg, '0')"/>
                </div>
            </div>
        </div>
        <div class="pb24 mb24 border-b">
            <div class="d-flex justify-content-between mb16" :class="{ 'align-items-start': this.isMobile, 'align-items-center': !this.isMobile }">
                <div class="neue fsp20 lh28 text-black">{{ $t('components.service.modal.AssetsFilter.11') }}</div>
                <div class="fsp16 neue text-decoration-underline ml16 main-color pointer lh28" @click="this.clear('category')">{{ $t('components.service.modal.AssetsFilter.2') }}</div>
            </div>
            <div class="d-flex flex-column gap-3">
                <div class="d-flex justify-content-between lh28">
                    <div class="neue-roman mr16">{{ $t('components.service.modal.AssetsFilter.12') }}</div>
                    <Checkbox id="category" :dataValue="this.fields.category === 'ART'" @updateParentState="(arg) => this.setValue(arg, 'ART')"/>
                </div>
                <div class="d-flex justify-content-between lh28">
                    <div class="neue-roman mr16">{{ $t('components.service.modal.AssetsFilter.13') }}</div>
                    <Checkbox id="category" :dataValue="this.fields.category === 'EMT'" @updateParentState="(arg) => this.setValue(arg, 'EMT')"/>
                </div>
                <div class="d-flex justify-content-between lh28">
                    <div class="neue-roman mr16">{{ $t('components.service.modal.AssetsFilter.14') }}</div>
                    <Checkbox id="category" :dataValue="this.fields.category === 'other_than_art_emt'" @updateParentState="(arg) => this.setValue(arg, 'other_than_art_emt')"/>
                </div>
                <div class="d-flex justify-content-between lh28">
                    <div class="neue-roman mr16">{{ $t('components.service.modal.AssetsFilter.15') }}</div>
                    <Checkbox id="category" :dataValue="this.fields.category === 'misc'" @updateParentState="(arg) => this.setValue(arg, 'misc')"/>
                </div>
            </div>
        </div>
        <div class="mb48">
            <div class="d-flex justify-content-between mb16" :class="{ 'align-items-start': this.isMobile, 'align-items-center': !this.isMobile }">
                <div class="neue fsp20 lh28 text-black">{{ $t('components.service.modal.AssetsFilter.16') }}</div>
                <div class="fsp16 neue text-decoration-underline ml16 main-color pointer lh28" @click="this.clear('secondary_market')">{{ $t('components.service.modal.AssetsFilter.2') }}</div>
            </div>
            <div class="d-flex flex-column gap-3">
                <div class="d-flex justify-content-between lh28">
                    <div class="neue-roman">{{ $t('components.service.modal.AssetsFilter.7') }}</div>
                    <Checkbox id="secondary_market" :dataValue="this.fields.secondary_market === '1'" @updateParentState="(arg) => this.setValue(arg, '1')"/>
                </div>
                <div class="d-flex justify-content-between lh28">
                    <div class="neue-roman">{{ $t('components.service.modal.AssetsFilter.8') }}</div>
                    <Checkbox id="secondary_market" :dataValue="this.fields.secondary_market === '0'" @updateParentState="(arg) => this.setValue(arg, '0')"/>
                </div>
            </div>
        </div>
        <div class="d-flex" :class="{ 'position-fixed bottom-0 left-0 end-0 py16 px24 w-100 border-t bg-white': this.isMobile }">
            <Button type="btn-warning" class="equal-width h48 mr16" @click="this.save()">{{ $t('components.service.modal.AssetsFilter.17') }}</Button>
            <Button type="btn-outline-grey" class="equal-width h48 primary-grey" @click="this.clearAll()">{{ $t('components.service.modal.AssetsFilter.18') }}</Button>
        </div>
    </div>
</template>
<script>
import Button from '@/components/service/Button.vue';
import Checkbox from '@/components/service/Checkbox.vue';
import Icon from '@/components/icons/Icon.vue';
export default {
    name: 'TableFilter',
    components: {
        Button,
        Checkbox,
        Icon
    },
    props: {
        close: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            callback: null,
            fields: {
                accept: '-1',
                active: '-1',
                access_atm_buy: '-1',
                access_atm_sell: '-1',
                category: '-1',
                secondary_market: '-1',
                type_filter_uid: '-1',
                uid: false,
            },
        }
    },
    mounted() {
        this.callback = this.$store.state.modal.content.callback;
        this.fields = this.$store.state.modal.content.fields;
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        }
    },
    methods: {
        isChecked(key, value) {
            return this.fields[key] === value;
        },
        save() {
            this.callback(this.fields);
            this.close();
        },
        clear(field) {
            console.log(field);
            this.fields[field] = '-1';
            console.log(this.fields);
        },
        setValue(arg, value) {
            if(this.fields[arg.id] === value) {
                this.fields[arg.id] = '-1';
            } else {
                this.fields[arg.id] = value;
            }
        },
        clearAll() {
            Object.keys(this.fields).forEach(field => {
                this.fields[field] = '-1';
            });
        }
    }
}
</script>
<style lang="scss" scoped>

</style>